
import arrow from "../../../img/arrow.png"
export function SelectOption(props) {
    return (
        <>
            {((props.option === 'Size' && props.choosedOptions.frontPlate !== 'false') ||
                (props.option !== 'Size' && props.option !== 'Slogan' && props.option !== 'Right Badge') ||
                (props.option === 'Slogan' && props.choosedOptions.categoryPlate.includes("show")) ||
                (props.option === 'Right Badge' && props.choosedOptions.categoryPlate.includes("show"))) &&
                <div className="option-box flex justify-between" onClick={() => props.openPopup(props.option)}>
                    <figure className="option-box__icon flex items-center justify-center">
                        <img src={props.image} alt="size icon" />
                    </figure>
                    <div className="option-box__text flex justify-center flex-col">
                        <div className="option-box__name">{props.option} {props.resultRear !== 'null' && props.resultRear !== undefined && props.resultRear !== props.result && props.choosedOptions.frontPlate !== 'false' && props.choosedOptions.rearPlate !== 'false' && <span>(FRONT)</span>}</div>
                        {props.option === 'Border Style' &&
                            <>{props.result !== 'null' && props.result !== 'None' && <div className="option-box__result">{props.result} {props.option === 'Border Style' && ' mm'}</div>}</>
                        }
                        {props.option !== 'Border Style' &&
                            <>{props.result !== 'null' && <div className="option-box__result">{props.result}</div>}</>
                        }
                    </div>

                    {(props.result === 'null' ||  props.result === 'None') &&
                        <div className="option-box__open-popup select-btn flex items-center" >
                            SELECT
                            <img src={arrow} alt="arrow" />
                        </div>
                    }
                    {(props.result !== 'null' && props.result !== 'None') &&
                        <div className="option-box__open-popup edit-btn flex items-center">
                            Edit
                        </div>
                    }

                </div>
            }
            {(( props.resultRear !== undefined && props.choosedOptions.rearPlate !== 'false' && props.resultRear !== props.result) || props.choosedOptions.frontPlate === 'false' && props.resultRear !== undefined) && 
            <div className="option-box flex justify-between " onClick={() => props.openPopup(props.option)}>
                <figure className="option-box__icon flex items-center justify-center">
                    <img src={props.image} alt="size icon" />
                </figure>
                <div className="option-box__text flex justify-center flex-col">
                    <div className="option-box__name">{props.option} {props.choosedOptions.frontPlate !== 'false' && <span>(REAR)</span>} </div>
                    {props.resultRear !== 'null' && <div className="option-box__result">{props.resultRear}</div>}
                </div>

                {props.resultRear === 'null' &&
                    <div className="option-box__open-popup select-btn flex items-center">
                        SELECT
                        <img src={arrow} alt="arrow" />
                    </div>
                }
                {props.resultRear !== 'null' &&
                    <div className="option-box__open-popup edit-btn flex items-center">
                        Edit
                    </div>
                }

            </div>
            }
        </>
    )
}